<main class="auth">

  <!-- ============ Brand panel ============ -->
  <section class="auth__brand">
    <svg class="auth__contours" viewBox="0 0 600 900" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
      <g fill="none" stroke="#D6C59D" stroke-width="1.4" stroke-linecap="round" opacity="0.22">
        <path d="M-40 640 Q150 560 320 640 T700 620" />
        <path d="M-40 690 Q150 610 320 690 T700 670" />
        <path d="M-40 742 Q150 662 320 742 T700 722" />
        <path d="M-40 796 Q150 716 320 796 T700 776" />
        <path d="M-40 850 Q150 770 320 850 T700 830" />
      </g>
      <g fill="none" stroke="#6A8A76" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" opacity="0.28">
        <path d="M-40 470 L120 360 L210 410 L370 250 L560 470" />
        <path d="M40 530 L190 430 L280 470 L420 330 L640 530" />
      </g>
    </svg>

    <div class="auth__brand-top">
      <!-- Logo lockup (cream tone) -->
      <svg width="40" height="40" viewBox="0 0 120 120" fill="none" aria-hidden="true">
        <defs>
          <clipPath id="frameC"><rect x="28.5" y="20.5" width="63" height="79" rx="15.5"></rect></clipPath>
        </defs>
        <rect x="26" y="18" width="68" height="84" rx="18" stroke="#F2E9DC" stroke-width="4.5"></rect>
        <g clip-path="url(#frameC)">
          <circle cx="46.5" cy="44" r="8.5" stroke="#D6C59D" stroke-width="3.6"></circle>
          <path d="M27 83 L43 66 L52 72 L70 48 L93 83" stroke="#F2E9DC" stroke-width="4" stroke-linejoin="round" stroke-linecap="round"></path>
          <path d="M26 87 Q43 79 60 87 T95 87" stroke="#D6C59D" stroke-width="3.6" stroke-linecap="round"></path>
          <path d="M26 96 Q45 87 62 96 T98 95" stroke="#D6C59D" stroke-width="3.6" stroke-linecap="round"></path>
        </g>
      </svg>
      <span class="belturo-wordmark" style="color: var(--belturo-cream); font-size: 1.4rem;">Belturo</span>
    </div>

    <div class="auth__brand-body">
      <p class="auth__brand-eyebrow"><%= _lcs( 'Plattform-Verwaltung' ) %></p>
      <h1 class="auth__brand-headline"><%= _lcs( 'Eine Plattform.' ) %> <em><%= _lcs( 'Viele Regionen.' ) %></em></h1>
      <p class="auth__brand-sub"><%= _lcs( 'Behalte den Überblick über alle Gastgeber, Tenants und Regionen — an einem Ort.' ) %></p>
    </div>

    <div class="auth__brand-foot">
      <i class="icon icon--shield-check"></i>
      <span><%= _lcs( 'Interner Operator-Zugang' ) %></span>
      <span class="auth__dot"></span>
      <span>BELTURO Cloud</span>
    </div>
  </section>

  <!-- ============ Form panel ============ -->
  <section class="auth__panel">
    <div class="auth__card">

      <!-- compact mark, mobile only -->
      <span class="auth__mark-mobile">
        <svg width="34" height="34" viewBox="0 0 120 120" fill="none" aria-hidden="true">
          <defs>
            <clipPath id="frameF"><rect x="28.5" y="20.5" width="63" height="79" rx="15.5"></rect></clipPath>
          </defs>
          <rect x="26" y="18" width="68" height="84" rx="18" stroke="#1F4B3F" stroke-width="4.5"></rect>
          <g clip-path="url(#frameF)">
            <circle cx="46.5" cy="44" r="8.5" stroke="#C2A461" stroke-width="3.6"></circle>
            <path d="M27 83 L43 66 L52 72 L70 48 L93 83" stroke="#1F4B3F" stroke-width="4" stroke-linejoin="round" stroke-linecap="round"></path>
            <path d="M26 87 Q43 79 60 87 T95 87" stroke="#1F4B3F" stroke-width="3.6" stroke-linecap="round"></path>
            <path d="M26 96 Q45 87 62 96 T98 95" stroke="#C2A461" stroke-width="3.6" stroke-linecap="round"></path>
          </g>
        </svg>
      </span>

      <p class="auth__eyebrow">SaaS Admin</p>
      <h2 class="auth__title"><%= _lcs( 'Willkommen zurück' ) %></h2>
      <p class="auth__subtitle"><%= _lcs( 'Melde dich an, um die BELTURO-Plattform zu verwalten.' ) %></p>

      <form class="auth__form" autocomplete="on" novalidate>
        <div class="field">
          <label class="field__label" for="email"><%= _lcs( 'E-Mail' ) %></label>
          <div class="field__control">
            <span class="field__icon"><i class="icon icon--mail"></i></span>
            <input class="field__input" id="email" name="email" type="email"
                   inputmode="email" autocomplete="username"
                   placeholder="name@belturo.com" required />
          </div>
        </div>

        <div class="field">
          <label class="field__label" for="password"><%= _lcs( 'Passwort' ) %></label>
          <div class="field__control">
            <span class="field__icon"><i class="icon icon--lock"></i></span>
            <input class="field__input" id="password" name="password" type="password"
                   autocomplete="current-password" placeholder="••••••••" required />
            <button class="field__toggle" type="button" id="togglePw"
                    aria-label="<%= _lcs( 'Passwort anzeigen' ) %>" aria-pressed="false">
              <i class="icon icon--eye"></i>
            </button>
          </div>
        </div>

        <div class="auth__options">
          <label class="checkbox">
            <input type="checkbox" name="remember" />
            <span class="checkbox__box"><i class="icon icon--check"></i></span>
            <%= _lcs( 'Angemeldet bleiben' ) %>
          </label>
          <a class="auth__link" href="#/password-forgotten" data-id="link-forgot-password"><%= _lcs( 'Passwort vergessen?' ) %></a>
        </div>

        <p class="auth__error" data-id="login-error" role="alert" hidden></p>

        <button class="btn btn--primary btn--block" type="submit">
          <%= _lcs( 'Anmelden' ) %>
          <i class="icon icon--arrow-right"></i>
        </button>
      </form>

      <div class="auth__hr"><%= _lcs( 'Geschützter Bereich' ) %></div>
      <p class="auth__note"><%= _lcs( 'Kein Zugang? Wende dich an die BELTURO-Administration.' ) %></p>
    </div>
  </section>

</main>
